import React, { useEffect, useRef, useState } from "react";
import "./HostDashBoard.scss";
import { PageHeader } from "@/components/header/header";
import Footer from "../Footer/Footer";
import { DashBoardLayout } from "./dashboard-layout/DashBoardLayout";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { eventRoomStore } from "@/stores/event";
import { toast } from "react-toastify";
import WelcomeLoader from "../WelcomeLoader/WelcomeLoader";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Cookies from "js-cookie";
import { buildProtectedRouteRedirect, isHostOrAdminUser } from "@/utils/auth/redirect";

export const HostDashBoard = () => {
  const history = useHistory();
  const location = useLocation();
  const params = useParams<any>();
  const UserId = params.userId ? params.userId.replace("&limit=4&page=1", "") : "";
  const isLoader = useRef<boolean>(true);
  const [eventDetailsData, seteventDetailsData] = useState<any[]>([]);
  const [filteredEvents, setFilteredEvents] = useState<any[]>([]);
  const [currentpage, setcurrentpage] = useState<number>(1);
  const [itemsPerPage, setitemsPerPage] = useState<number>(4);
  const [totalPosts, setTotalPosts] = useState<number>(0);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isAccessAllowed, setIsAccessAllowed] = useState<boolean | null>(null);

  const getVisitDetails = async (page: number) => {
    setIsLoading(true);
    try {
      const visitDetails: any = await eventRoomStore.fetchUserVisits(UserId, page, itemsPerPage);
      if (visitDetails.status === 200) {
        const entries = Array.isArray(visitDetails.visits?.entries)
          ? visitDetails.visits.entries
          : [];

        setTotalPosts(visitDetails.visits.total_visits || entries.length);
        isLoader.current = false;

        const today = new Date().toISOString().split('T')[0];
        const filtered = entries.filter((event: any) => {
          const visit = event?.data ?? event;
          const visitDate = visit?.date || visit?.time_in_utc || visit?.time || "";
          if (!visitDate) return false;
          return new Date(visitDate).toISOString().split('T')[0] === today;
        });

        setFilteredEvents(filtered);
        seteventDetailsData(entries);
        setError(null);
      } else if (visitDetails.status === 404) {
        toast.error("No Visit Details found");
        window.location.href = "/404";
      } else {
        toast.error("Error fetching Visit Details");
      }
    } catch (err) {
      toast.error("An unexpected error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const savedPage = sessionStorage.getItem('currentpage');
    if (savedPage) {
      setcurrentpage(parseInt(savedPage, 10));
    }
  }, []);

  useEffect(() => {
    const checkAccess = async () => {
      const token = Cookies.get("token") || Cookies.get("accessToken");
      if (!token) {
        history.replace(buildProtectedRouteRedirect(location.pathname + location.search));
        return;
      }

      const currentUser = await eventRoomStore.getAuthorizedCurrentUser();
      if (!currentUser) {
        Cookies.remove("token");
        Cookies.remove("accessToken");
        Cookies.remove("refreshToken");
        history.replace(buildProtectedRouteRedirect(location.pathname + location.search));
        return;
      }

      const userIsHostOrAdmin = isHostOrAdminUser(currentUser);
      if (!userIsHostOrAdmin) {
        history.replace("/error/access-denied");
        return;
      }

      const requestedUserId = String(UserId || "");
      const isAdmin = Boolean(currentUser.is_superuser || (currentUser.groups || []).includes("Admin"));
      if (!isAdmin && requestedUserId && String(currentUser.id) !== requestedUserId) {
        history.replace(`/visits/${currentUser.id}`);
        return;
      }

      setIsAccessAllowed(true);
    };

    checkAccess();
  }, [history, location.pathname, location.search, UserId]);

  useEffect(() => {
    if (isAccessAllowed !== true) return;
    getVisitDetails(currentpage);
    sessionStorage.setItem('currentpage', currentpage.toString());
  }, [currentpage, itemsPerPage, isAccessAllowed]);

  useEffect(() => {
    console.log("eventDetailsData", eventDetailsData);
  }, [eventDetailsData]);

  useEffect(() => {
    console.log("Current Page After Update:", currentpage);
  }, [currentpage]);

  const totalPages = Math.ceil(totalPosts / itemsPerPage);

  const pageHandler = (type: "forward" | "backward") => {
    if (type === "forward" && currentpage < totalPages) {
      console.log("Current Page Before Update (Forward):", currentpage);
      setcurrentpage((prevPage) => {
        const newPage = prevPage + 1;
        console.log("Next Page (Forward):", newPage);
        return newPage;
      });
    }
    if (type === "backward" && currentpage > 1) {
      console.log("Current Page Before Update (Backward):", currentpage);
      setcurrentpage((prevPage) => {
        const newPage = prevPage - 1;
        console.log("Next Page (Backward):", newPage);
        return newPage;
      });
    }
  };

  if (isAccessAllowed === null) {
    return <WelcomeLoader />;
  }

  return (
    <div className="host-dashboard-page">
      <PageHeader ShowOffer={true} Showcontact={true} />
      {error && <div>{error}</div>}
      <div className="dashboard-events">
        {isLoading ? (
          <WelcomeLoader />
        ) : (
          <div className="dashboard-events-content">
            {filteredEvents.length > 0 ? (
              <>
                {filteredEvents.map((event: any) => {
                  const visit = event?.data ?? event;
                  return (
                    <DashBoardLayout
                      key={visit?.id}
                      data={visit}
                    />
                  );
                })}
                {totalPosts > itemsPerPage && (
                  <div className="pagination">
                    {currentpage > 1 && (
                      <button onClick={() => pageHandler("backward")}>
                        <ArrowBackIcon />
                      </button>
                    )}
                    {currentpage < totalPages && (
                      <button onClick={() => pageHandler("forward")}>
                        <ArrowForwardIcon />
                      </button>
                    )}
                  </div>
                )}
              </>
            ) : (
              <div className="dashboard-events-content-error">
                <p>No Visit is Scheduled right now</p>
                {totalPosts > itemsPerPage && (
                  <div className="pagination">
                    {currentpage > 1 && (
                      <button onClick={() => pageHandler("backward")}>
                        <ArrowBackIcon />
                      </button>
                    )}
                  </div>
                )}
                <Link to="/visits" className="centered-link">
                  Go to Visits
                </Link>
              </div>
            )}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};
